import React, { useEffect, useState, useContext } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Navbar, Button } from "react-bootstrap";
import {
  InfoIcon,
  ContentIcon,
  ApprovalCommentIcon,
  TeamCommentIcon,
  DraftCommentIcon,
  RedDot
} from '../../../../components';
import { isDraftHasValue } from '../../../../utils/isDraftHasValue';

function MobileContenGroupNav(props) {
  const {
    can_access_show_content_details,
    can_access_team_comment,
    can_access_show_team_comment,
    activeTab,
    setActiveTab,
    tab,
    setTab,
    internal_draft,
    partner_draft,
  } = props
  const dispatch = useDispatch();

  const show_team_tab = can_access_team_comment || can_access_show_team_comment;
  const has_internal_draft =  isDraftHasValue(internal_draft);
  const has_partner_draft = isDraftHasValue(partner_draft);
  const onClickComment = (comment_type) =>{
    setTab('comments')
    setActiveTab(comment_type)
  }
  const {
    draft_comment_loading,
    update_comment_loading,
    draft_attachment_loading,
    comment_tab_loading,
    draft_render_loading
  } = useSelector(state => state.comment);
  const {
    currentContentGroup: content_group,
  } = useSelector(state => state.content);

  const loading = 
    draft_comment_loading || 
    update_comment_loading || 
    draft_attachment_loading || 
    comment_tab_loading || 
    draft_render_loading;

  return (
    <Navbar
      className="mobile_navigation fixed-bottom p-0"
      sticky="bottom"
    >
      <div
        className="mobile_navigation-button_group w-100 h-100 d-flex align-item-center"
      >
        {
          can_access_show_content_details &&
          <Button
            size={"sm"}
            variant={"transparent"}
            className={ tab === 'info' ? 'active' : '' }
            onClick={() => setTab('info')}
          >
            <InfoIcon
              className="m-auto d-block"
              height={"20"}
              width={"20"}
            />
            Info
          </Button>
        }
        <Button
          size={"sm"}
          variant={"transparent"}
          className={ tab === 'contents' ? 'active' : '' }
          onClick={() => setTab('contents')}
        >
          <ContentIcon
            className="m-auto d-block"
            height={"20"}
            width={"20"}
          />
          Content
        </Button>

        {
          show_team_tab &&
          <Button
            size={"sm"}
            variant={"transparent"}
            className={ tab === 'comments' && activeTab === 'internal_notes' ? 'active' : '' }
            onClick={() => loading ? null : onClickComment('internal_notes')}
          >
            <div
              className="d-flex justify-content-center"
            >
              <div
                className='position-relative'
                style={{ width: 20 }}
              >
              <TeamCommentIcon
                height={"20"}
                width={"20"}
                style={ has_internal_draft ? { } : {} }
              />

                <div
                  className='position-absolute ms-2 d-flex'
                  style={{ top: '50%', left: '60%', zIndex: 1, transform: 'translateY(-50%)' }}
                >
                  {
                    content_group?.unread_comments?.team && <RedDot className='m-1 d-block'/>
                  }

                  { 
                    has_internal_draft && 
                    <DraftCommentIcon className={'m-1 d-block'} height={12} width={12}/>
                  } 
                </div>
              </div>

            </div>

            Team
          </Button>
        }
        <Button
          size={"sm"}
          variant={"transparent"}
          className={ tab === 'comments' && activeTab === 'discussion' ? 'active' : '' }
          onClick={() => loading ? null : onClickComment('discussion')}
        >
          <div
            className="d-flex justify-content-center"
          >
              <div
                className='position-relative'
                style={{ width: 20 }}
              >
                <ApprovalCommentIcon
                  height={"20"}
                  width={"20"}
                  style={ has_partner_draft ? {} : {} }
                />

                <div
                  className='position-absolute ms-2 d-flex'
                  style={{ top: '50%', left: '60%', zIndex: 1, transform: 'translateY(-50%)' }}
                >
                  {
                    content_group?.unread_comments?.guest && <RedDot className='mx-1'/>
                  }

                  { 
                    has_partner_draft && 
                    <DraftCommentIcon className={'mx-1'} height={12} width={12}/>
                  } 
                </div>
              </div>
          </div>

          Guest
        </Button>
      </div>
    </Navbar>
  );
}

const mapStateToProps = (state) => {
  return {
    activeTab: state.comment.activeTab,
    can_access_show_content_details: state.content.can_access_show_content_details,
    can_access_team_comment: state.content.can_access_team_comment,
    can_access_show_team_comment: state.content.can_access_show_team_comment,
    internal_draft: state.comment.internal_draft,
    partner_draft: state.comment.partner_draft,
    can_add: state.content.can_add,
  };
};

export default connect(mapStateToProps, { })(MobileContenGroupNav);
